/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { reads, or, not, and } from '@ember/object/computed';
import Component from '@ember/component';
import { isEmpty } from '@ember/utils';
import { tagName } from '@ember-decorators/component';

@tagName('')
export default class Content extends Component {
  @service api;
  @service apiErrors;
  @service alerts;
  @service auth;
  @service environment;
  @service push;

  // external API
  platform = null;

  provider = null;
  isEditing = false;
  selectedFile = null;
  isEnabled = false;
  isDisabled = false;
  shouldEnableiOSViaFCM = false;
  errors = null;
  onFileSelected() {}

  // internal API
  @reads('push.credentials.fcm.username') fileName;
  @not('isEditing') isNotEditing;
  @not('shouldEnableiOSViaFCM') isNotStaticConfig;
  @or('shouldEnableiOSViaFCM', 'isNotEditing') isStaticConfigOrNotEditing;
  @and('isStaticConfigOrNotEditing', 'fileName') showCurrentConfiguration;

  get disableInput() {
    return (
      !this.auth.hasPermission('journeys/push_message_settings/edit') ||
      this.push.isAnyRequestRunning ||
      this.isNotEditing
    );
  }

  @computed('disableInput')
  get fileSelectTooltip() {
    return this.disableInput ? 'Click Edit Authorization to upload file.' : 'Upload .json server key file';
  }

  @computed('fileName', 'selectedFile')
  get fileNameToDisplay() {
    return !this.selectedFile ? `${this.fileName} (current)` : this.selectedFile.name;
  }

  @action
  fileSelected(file, resetInput) {
    if (isEmpty(file)) {
      return;
    }

    this.onFileSelected(file);
    resetInput();
  }
}
